import { t } from '../../i18n';
import { useState, useEffect } from 'react';

const facts = [
  { text: t("10+ years of experience"), icon: '/' },
  { text: t("Full-stack developer"), icon: '/' },
  { text: t("AI & ML specialist"), icon: '/' },
  { text: t("Based in Angers, France"), icon: '/' },
];

const RotatingFacts = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % facts.length);
        setIsVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className={`mb-12 transition-all duration-700 ease-out-expo ${
        mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="flex items-center gap-4">
        {/* Progress dots */}
        <div className="flex gap-1.5">
          {facts.map((_, index) => (
            <span
              key={index}
              className={`w-1.5 h-1.5 rounded-full transition-all duration-500 ${
                index === currentIndex
                  ? 'bg-primary w-4'
                  : 'bg-foreground/10'
              }`}
            />
          ))}
        </div>

        {/* Rotating text */}
        <div className="overflow-hidden h-6">
          <p
            className={`text-sm text-muted font-heading tracking-wide transition-all duration-500 ease-out-expo ${
              isVisible
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 -translate-y-4'
            }`}
          >
            {facts[currentIndex].text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default RotatingFacts;
